import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
    page: {
        flexGrow: 1,
        display: "flex",
        flexFlow: "column nowrap",
        width: "100%",
        overflow: "auto"
    }
});

export default function Page({ children }) {
    const classes = useStyles();
    return (
        <div className={classes.page}>
            {children}
        </div>
    )
}